import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Table, Image, Button, Row } from "react-bootstrap";
import moment from "moment";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { IconBoxReusableSeatingComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";

import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  admin_get_vendor_seating_summary_r_I,
  admin_get_all_request_count,
} from "../../../../store/actions/SuperAdminActions/adminVendorSummaryReportsAction";
import {
  sa_whole_vd_seating_diner,
  sa_whole_vd_pending_diner,
  sa_whole_vd_reservation_diner,
} from "../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import isEmpty from "../../../../store/validation/is-Empty";
import TableSizePopup from "../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import { SeatingStatus } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import EventCountDownTimer from "../../../reusableComponents/allPopupReusable/tableNumberPopup/EventCountDownTimer";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import BasicPagination from "../../../Pagination/Pagination";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
const seatingWhite = require("../../../../assets/images/seatingImages/newseaticon.svg");

function SuperAdminSeatingActivityReport(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth?.user?.accessToken : "";
  });

  const [filterDropDown, setFilterDropDown] = useState("");
  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    restaurantReverse: "",
    open: false,
    showStatus: "All",
    showStatusText: "",
    openPax: false,
    showPax: "All",
    showPaxText: "",
    showSearch: false,
  });

  /*********************************
   * @DESC Show Status Modal Action
   *********************************/
  const onOpenModal = () => {
    setState({ ...state, open: true });
  };
  const onCloseModal = () => {
    setState({ ...state, open: false });
  };
  const bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    setState({
      ...state,
      showStatusText: type,
    });
  };
  const selectStatusClick = (e) => {
    setState({
      ...state,
      showStatus: state.showStatusText === "" ? "All" : state.showStatusText,
      open: false,
    });
  };

  /*********************************
   * @DESC Show Pax Modal Action
   *********************************/
  const onOpenModalPax = (e) => {
    setState({
      ...state,
      openPax: true,
    });
  };
  const onCloseModalPax = (e) => {
    setState({
      ...state,
      openPax: false,
    });
  };
  const bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    setState({
      ...state,
      showPaxText: type,
    });
  };
  const selectPaxClick = (e) => {
    setState({
      ...state,
      showPax: state.showPaxText === "" ? "All" : state.showPaxText,
      openPax: false,
    });
  };

  /*********************************
   * @DESC Filter Modal Action
   *********************************/
  const [filter, showFilter] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setState({
      ...state,
      restaurantReverse: value,
      restaurant_type: "",
    });
    handleClose();
  };

  const onChangeRestaurantType = (e) => {
    setFilterDropDown(e.target.value);
  };

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const onFilterSave = (e) => {
    setState({
      ...state,
      restaurant_type: filterDropDown,
    });
    showFilter(!filter);
  };

  /*************************************************
   * @DESC FIRST TIME LOAD COMPONENT API AND STATE
   *************************************************/
  useEffect(() => {
    const token = props.auth.user.accessToken;
    dispatch(admin_get_vendor_seating_summary_r_I(token));
    dispatch(admin_get_all_request_count(token, true, "SEATING"));
  }, []);

  /*******************************************/
  const [vendorList, setVendorList] = useState([]);
  useEffect(() => {
    setVendorList(props.getAllVendorList);
  }, [props.getAllVendorList]);

  /*************************************************
   * @DESC TABLE BODY COMPONENT FUNCTION
   *************************************************/
  let filteredData = [];
  const RenderTableBody = () => {
    const smsDataArr = vendorList && vendorList;

    if (
      state.showPax === "All" &&
      state.showStatus === "All" &&
      state.restaurant_type === "" &&
      state.restaurantReverse === ""
    ) {
      filteredData = smsDataArr;
    } else if (state.showPax === "8>") {
      filteredData = smsDataArr.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (state.showPax === "8") {
      filteredData = smsDataArr.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (state.showPax === "6") {
      filteredData = smsDataArr.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (state.showPax === "4") {
      filteredData = smsDataArr.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (state.showPax === "2") {
      filteredData = smsDataArr.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (state.showStatus === "Not Seated") {
      filteredData = smsDataArr.filter(
        (dinner) => dinner.diner_status === "NOTSEATED"
      );
    }
    if (state.showStatus === "Seated") {
      filteredData = smsDataArr.filter(
        (dinner) => dinner.diner_status === "SEATED"
      );
    }
    if (state.restaurant_type !== "") {
      filteredData = smsDataArr.filter(
        (restaurant) =>
          restaurant.primary_restaurant_type &&
          restaurant.primary_restaurant_type[0] &&
          restaurant.primary_restaurant_type[0].title === state.restaurant_type
      );
    }
    if (state.restaurantReverse === "A-Z") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return -1;
        if (a.restaurant_name > b.restaurant_name) return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return 1;
        if (a.restaurant_name > b.restaurant_name) return -1;
        return 0;
      });
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = smsDataArr.filter((getall) => {
        if (search.test(getall?.user_details?.name)) {
          return getall;
        } else if (search.test(getall?.restaurant?.restaurant_name)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    // else {
    //   filteredData = smsDataArr;
    // }
    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <TableBody
            smsInfo={data}
            onClickVendorId={() => onClickVendorId(data)}
          />
        </React.Fragment>
      ));
    }
  };

  const onClickVendorId = (data) => {
    dispatch(
      sa_whole_vd_pending_diner(
        token,
        data.vendor_id,
        data.restaurant.subscription,
        (vendorId, subscriptionId) => onSuccess(vendorId, subscriptionId)
      )
    );
    dispatch(
      sa_whole_vd_reservation_diner(
        token,
        data.vendor_id,
        data.restaurant.subscription,
        (vendorId, subscriptionId) => onSuccess(vendorId, subscriptionId)
      )
    );
  };

  const onSuccess = (vendorId, subscriptionId) => {
    localStorage.setItem("vendorId", JSON.stringify(vendorId));
    localStorage.setItem("subscriptionId", JSON.stringify(subscriptionId));
    history.push({
      pathname: `/superadmin/vendorseating`,
      state: {
        vendorID: vendorId,
        subscriptionId: subscriptionId,
        // pageBackUrl: `/superadminseatingall`,
        pageAction: "SEATING",
      },
    });
  };

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const downloadData = {
    headers: [
      { label: "Business Name/Id", key: "bid" },
      { label: "Request Type ", key: "resType" },
      { label: "Name /Request Number", key: "requests" },
      { label: "Total PAX", key: "pax" },
      { label: "Date/Time \n Timer", key: "date" },
      { label: "Seating Preference", key: "seatingpref" },
      { label: "Table Room No.", key: "tableno" },
      { label: "Status", key: "Status" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
          console.log(filteredData, "***************");
          return {
            bid: ele?.restaurant?.restaurant_name,
            resType: ele?.service_type,
            requests: `${ele?.user_details?.name} \n ${ele?.diner_id}  `,
            pax: ele?.adult_count + ele?.kids_count,
            date: `${moment(ele?.createdAt).format("Do-MMM-YYYY")}  ${moment(
              ele?.createdAt
            ).format("hh:mm A")}`,
            seatingpref: ele?.seating_preference[0],
            tableno: `${
              ele?.room_number !== undefined && ele?.room_number !== null
                ? ele?.room_number
                : ""
            } \n 
                        ${
                          ele?.table_number !== undefined &&
                          ele?.table_number !== null
                            ? ele?.table_number
                            : ""
                        }`,
            Status: ele?.diner_status,
          };
        })
      : [],
  };

  if (props.auth.secondary_loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="Reports" />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    Seating Activity Dashboard
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-3 mb-3">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 seating-left-side-navigation">
                    <div className="row">
                      <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                        <IconBoxReusableSeatingComponent
                          classSection={
                            "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                          }
                          // imageStyle="inside-image-button"
                          src={seatingWhite}
                          iconText="Seating"
                          iconTextStyle={
                            "icon-bottom-text icon-bottom-text-active"
                          }
                          link="#"
                          bedgeClass="badge custom-icon-button-badge custom-badge-position-pending"
                          displayNotification={true}
                          notificationCount={props.getAllVendorList.length}
                          bottomLine={"bottom-box-line"}
                        />
                      </div>
                    </div>
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Total requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.totalRequest,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Walk-in/Waitlist requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.walkInWaitRequest,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Reservation Requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.reservationRequest,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
                <hr />
                <div className="row">
                  <div className="col-4 d-flex align-items-end">
                    <Image
                      onClick={() =>
                        // this.setState({ showSearch: !this.state.showSearch })
                        setState({
                          ...state,
                          showSearch: !state.showFilter,
                        })
                      }
                      alt="filter"
                      title="filter"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => showFilter(!filter)}
                    >
                      <img
                        src={require("../../../../assets/images/seatingImages/filter.svg")}
                        width="80px"
                      />
                      <br />
                      {/* Filter */}
                    </div>
                    <SortByMenu
                      handleClick={handleClick}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      selectClick={(data) => handleSelect(data)}
                    />
                    <div className="f10-400" align="center">
                      <CSVDownloader
                        filename={" Seating  Activity Report"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </div>
                  <div className="col-7 d-flex align-items-center">
                    <div className="row w-100">
                      <div
                        className="col-4"
                        style={{ borderRight: "1px solid #E0E0E0" }}
                      >
                        <SeatingStatus
                          status={state.showStatus}
                          onOpenModal={onOpenModal}
                          onCloseModal={onCloseModal}
                          open={state.open}
                          seatingStatus={state.showStatusText}
                          onClickAll={(e) =>
                            bigButtonShowStatusHandler(e, "All")
                          }
                          onClickSeated={(e) =>
                            bigButtonShowStatusHandler(e, "Seated")
                          }
                          onClickNonSeated={(e) =>
                            bigButtonShowStatusHandler(e, "Not Seated")
                          }
                          onStatusClick={selectStatusClick}
                          displayNotSeatedButton={true}
                        />
                      </div>
                      <div
                        className="col-3"
                        style={{ borderRight: "1px solid #E0E0E0" }}
                      >
                        <TableSizePopup
                          showPax={state.showPax}
                          onOpenModal={onOpenModalPax}
                          open={state.openPax}
                          onCloseModal={onCloseModalPax}
                          table_size={state.showPaxText}
                          onClickAll={(e) => bigButtonShowPaxHandler(e, "All")}
                          onClickTwo={(e) => bigButtonShowPaxHandler(e, "2")}
                          onClickFour={(e) => bigButtonShowPaxHandler(e, "4")}
                          onClickSix={(e) => bigButtonShowPaxHandler(e, "6")}
                          onClickEight={(e) => bigButtonShowPaxHandler(e, "8")}
                          graterThanEight={(e) =>
                            bigButtonShowPaxHandler(e, "8>")
                          }
                          selectPaxClick={selectPaxClick}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2 d-flex align-items-end">
                    <div className="w-100 d-flex align-items-center justify-content-between"></div>
                  </div>
                </div>
                {state.showSearch && (
                  <div className="mb-3">
                    <ZoomDiv>
                      <>
                        <br />
                        <Form.Control
                          type="text"
                          placeholder="Search by business name, diner name"
                          name="search"
                          onChange={onSearchChange}
                          value={state.search}
                          className="amSearch"
                        />
                      </>
                    </ZoomDiv>
                  </div>
                )}
                {filter && (
                  <div className="mt-3 mb-3">
                    <Row>
                      <div className="col-3">
                        <div className="mr-3">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">
                              Restaurant Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="restaurantType"
                              value={state.filterDropDown}
                              onChange={(e) => onChangeRestaurantType(e)}
                              label="date_range"
                            >
                              {props.restaurant_type &&
                                props.restaurant_type.map((item, index) => (
                                  <MenuItem key={index} value={item.title}>
                                    {item.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </Row>
                    <div class="d-flex align-items-center mt-2">
                      <button
                        type="button"
                        className="btn-md mr-4 px-5 btn btn-outline-secondary"
                        onClick={() => showFilter(!filter)}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn-md px-5 btn btn-danger"
                        onClick={onFilterSave}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                )}
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <td style={{ width: "20%" }} className="f12-400">
                          Business <br />
                          Name/ID
                        </td>
                        <td style={{ width: "6%" }} className="f12-400">
                          Request <br />
                          Type
                        </td>
                        <td style={{ width: "14%" }} className="f12-400">
                          Name / <br />
                          Request Number
                        </td>
                        <td style={{ width: "10%" }} className="f12-400">
                          Total PAX
                        </td>
                        <td style={{ width: "10%" }} className="f12-400">
                          Date / Time <br />
                          Timer
                        </td>
                        <td
                          style={{ width: "10%" }}
                          className="f12-400 text-center"
                        >
                          Seating <br />
                          Preference
                        </td>
                        <td style={{ width: "10%" }} className="f12-400">
                          Table/ <br />
                          Room No.
                        </td>
                        <td style={{ width: "10%" }} className="f12-400">
                          Status
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Actions
                        </td>
                      </tr>
                    </thead>
                    {RenderTableBody()}
                  </Table>
                </div>

                {/* {vendorList && vendorList?.length !== 0 ? ( */}
                <BasicPagination
                  totalRecords={vendorList.length}
                  limit={4}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
                {/* ) : (
                  <></>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminSeatingActivityReport.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  admin_get_vendor_seating_summary_r_I: propTypes.func.isRequired,
  admin_get_all_request_count: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant_type: state.category.restaurant_type,
  getAllVendorList:
    state.superAdminVendorSummaryReports.get_seating_activity_summary,
  getAllCount:
    state.superAdminVendorSummaryReports.get_all_seating_count_reports,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_get_vendor_seating_summary_r_I,
  admin_get_all_request_count,
  sa_whole_vd_seating_diner,
  sa_whole_vd_pending_diner,
  sa_whole_vd_reservation_diner,
})(withRouter(SuperAdminSeatingActivityReport));

const SortByMenu = (props) => {
  return (
    <div>
      <div
        className="f10-400"
        align="center"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={props.handleClick}
      >
        <img
          src={require("../../../../assets/images/iconButton/sortbtn.svg")}
          width="80px"
        />
        <br />
        {/* Sort */}
      </div>
      <Menu
        id="simple-menu"
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleClose}
      >
        <MenuItem onClick={props.selectClick} disabled>
          Restaurant Name
        </MenuItem>
        <MenuItem onClick={props.selectClick("A-Z")}>A-Z</MenuItem>
        <MenuItem onClick={props.selectClick("Z-A")}>Z-A</MenuItem>
      </Menu>
    </div>
  );
};

const TableBody = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props?.smsInfo?.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props?.smsInfo?.wait_time_date || props?.smsInfo?.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = props?.smsInfo?.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props?.smsInfo?.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  return (
    <tbody className="seating-dashboard-body-new">
      <tr
        className={`super_admin_all_users_table_body cursor enGrayBorderBox sd_body_tr ${
          props?.smsInfo?.userConfirmed === true ? "td_b_g" : "td_b_o"
        }`}
      >
        <td style={{ width: "20%" }} className="f12-500">
          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
            <div className="super-admin-suggestion-imageBoxOne enIMG33">
              {/* w-50 */}
              <img
                src={props.smsInfo?.restaurant?.logo_url}
                alt="Icon"
                title={props.smsInfo?.restaurant?.restaurant_name}
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="super-admin-suggestion-imageBoxTwo ml-2">
              <div className="f12-500">
                {props.smsInfo?.restaurant?.restaurant_name} <br />
                <p className="f10-500 mt-3">
                  City:{" "}
                  <span className="f10-400">
                    {props.smsInfo?.restaurant?.city}
                  </span>
                </p>
                <p className="f10-500">
                  Area:{" "}
                  <span className="f10-400">
                    {props.smsInfo?.restaurant?.area}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </td>
        <td style={{ width: "6%" }} className="f12-500">
          <Image
            src={
              props.smsInfo?.service_type === "RESERVATION"
                ? require("../../../../assets/images/ActionImages/image/reservation.svg")
                : props.smsInfo?.isWalkIn === false &&
                  props.smsInfo?.service_type === "SEATING"
                ? require("../../../../assets/images/ActionImages/image/waitlist.svg")
                : require("../../../../assets/images/ActionImages/image/walkin.svg")
            }
            alt={
              props.smsInfo?.service_type === "RESERVATION"
                ? "Reservation"
                : props.smsInfo?.isWalkIn === false &&
                  props.smsInfo?.service_type === "SEATING"
                ? "Waitlist"
                : "Walkin"
            }
            title={
              props.smsInfo?.service_type === "RESERVATION"
                ? "Reservation"
                : props.smsInfo?.isWalkIn === false &&
                  props.smsInfo?.service_type === "SEATING"
                ? "Waitlist"
                : "Walkin"
            }
            width="30px"
          />
        </td>
        <td style={{ width: "14%" }}>
          <p
            style={{
              fontSize: "14px",
            }}
            className="f12-500"
          >
            {props.smsInfo?.user_details?.name}
          </p>
          <div className="f10-400">#{props.smsInfo?.diner_id}</div>
        </td>
        <td style={{ width: "10%" }} className="f12-500">
          <div className="total-pax-body">
            <div className="col d-flex p-0">
              <div className="total-pax-body-inside">
                <h4 className="font_24_b">
                  {props.smsInfo?.adult_count + props.smsInfo?.kids_count}
                </h4>
                {/* <p className="total-pax-light-text">PAX</p> */}
              </div>
              <div className="total-adult-kids">
                <div className="display-align">
                  <Image
                    src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                    alt="Adult"
                    title="Adult"
                    className="pax-type-Image"
                  />
                  <p className="font_12_m ml-1 mr-1">
                    {props.smsInfo?.adult_count}
                  </p>
                </div>
                <div className="display-align">
                  <Image
                    src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                    alt="Kids"
                    title="Kids"
                    className="pax-type-Image"
                  />
                  <p className="font_12_m ml-1 mr-1">
                    {props.smsInfo?.kids_count}
                  </p>
                </div>
              </div>
              <div className="total-highchair-handicapp">
                {/* {props.dinerInfo.high_chair === 0 ? null : ( */}
                <div className="display-align">
                  <Image
                    src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                    alt="Highchair"
                    title="Highchair"
                    className="pax-type-Image"
                  />
                  <p className="font_12_m ml-1 mr-1">
                    {props.smsInfo?.high_chair}
                  </p>
                </div>
                {/* )}
                    {props.dinerInfo.handicap_chair === 0 ? null : ( */}
                <div className="display-align">
                  <Image
                    src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                    alt="Handicapped"
                    title="Handicapped"
                    className="pax-type-Image"
                  />
                  <p className="font_12_m ml-1 mr-1">
                    {props.smsInfo?.handicap_chair}
                  </p>
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        </td>
        <td style={{ width: "10%" }} className="f12-500">
          <div className="date-time-timer-body">
            <div className="time-and-edit-button">
              <div className="timer-section mr-2">
                <h4 className="f15-700" style={{ color: "#ee3a23" }}>
                  {props?.smsInfo?.wait_time !== undefined &&
                  props?.smsInfo?.wait_time !== null ? (
                    props?.smsInfo?.service_type === "RESERVATION" ? (
                      <NewCountDown waitNew={diff} />
                    ) : (
                      <EventCountDownTimer waitNew={diff} />
                    )
                  ) : (
                    "00:00:00"
                  )}
                </h4>
              </div>
            </div>
          </div>
          <div className="f12-400">
            {moment(
              props.smsInfo?.reservationTime || props.smsInfo?.createdAt
            ).format("Do-MMM-YYYY")}{" "}
            <br />
            {moment(
              props.smsInfo?.reservationTime || props.smsInfo?.createdAt
            ).format("hh:mm A")}
          </div>
        </td>
        <td style={{ width: "10%" }} className="f12-400 text-center">
          <p className="f12-500">{props.smsInfo?.seating_preference[0]}</p>
        </td>
        <td style={{ width: "10%" }} className="f12-500">
          <p className="f12-500 col-12 p-0">
            {props.smsInfo?.room_number !== undefined &&
            props.smsInfo?.room_number !== null &&
            props.smsInfo?.room_number !== ""
              ? "Room No. :"
              : ""}{" "}
            {props.smsInfo?.room_number !== undefined &&
            props.smsInfo?.room_number !== null
              ? props.smsInfo?.room_number
              : ""}
          </p>
          <p className="f12-500 col-12 p-0">
            {props.smsInfo?.table_number !== undefined &&
            props.smsInfo?.table_number !== null &&
            props.smsInfo?.table_number !== ""
              ? "Table no:"
              : ""}{" "}
            {props.smsInfo?.table_number !== undefined &&
            props.smsInfo?.table_number !== null
              ? props.smsInfo?.table_number
              : ""}
          </p>
        </td>
        <td style={{ width: "10%" }}>
          <p className="f12-500">{props.smsInfo?.diner_status}</p>
        </td>
        <td style={{ width: "15%" }}>
          <div
            className="p-2 f10-700"
            style={{
              border: "1px solid rgb(238, 58, 35)",
              borderRadius: "5px",
            }}
            onClick={props.onClickVendorId}
            align="center"
          >
            <Image
              src={require("../../../../assets/images/ActionImages/image/onboarding.svg")}
              alt="Dashboard"
              title="Dashboard"
              fluid
              className="mr-2"
              width="20px"
            />
            View Dashboard
          </div>
        </td>
      </tr>
    </tbody>
  );
};
